import useTypedFlags from "hooks/useTypedFlags";

import useCanManageApiKeys from "./useCanManageApiKeys";

const useCanViewUsersPersonalApiKeys = () => {
  const { personalApiKeys } = useTypedFlags();
  const canManageApiKeys = useCanManageApiKeys();

  return personalApiKeys && canManageApiKeys;
};

export default useCanViewUsersPersonalApiKeys;
